/* eslint-disable no-unused-vars */
/* global __CLIENT__ */

// import { React, useState, useEffect, useCallback } from 'react';
import React, {
    useState, useEffect, useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import ReactModal from 'react-modal';
import { UnmountClosed } from 'react-collapse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
// import cookie from 'cookie';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
import Login from '../containers/LoginContainer';
import Register from '../containers/RegisterContainer';
import ConfirmEmail from '../containers/ConfirmEmailContainer';
import RequestPasswordReset from '../containers/RequestPasswordResetContainer';
import ResetPassword from '../containers/ResetPasswordContainer';
import { showError } from '../../../common/A1Alert/A1Alert';

const ProfileModal = ({
    isLoggedIn,
    isOpen,
    submitting,
    setProfileModalState,
    user,
    firebasePopupOpen,
    currentStream,
    setStream,
    logout,
}) => {
    const [currentScreen, setCurrentScreen] = useState('login');
    const [userId, setUserId] = useState(null);
    const [confirmEmailCode, setConfirmEmailCode] = useState(null);
    // const [setLogoutBtnClicked] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const params = queryString.parse(location.search);

    const _handleClose = () => setProfileModalState(false);

    const _handleQueryParams = useCallback((queryParams) => {
        if (queryParams.profile) {
            setProfileModalState(true);

            const screen = queryParams.screen;

            switch (screen) {
                case 'register':
                    setCurrentScreen('register');

                    break;

                case 'requestPasswordReset':
                    setCurrentScreen('request-password-reset');

                    break;

                case 'confirmEmail':
                    setCurrentScreen('confirm-email');

                    setUserId(Number(queryParams.userId) || null);

                    setConfirmEmailCode(queryParams.code || null);

                    break;

                case 'resetPassword':
                    setCurrentScreen('reset-password');

                    setUserId(Number(queryParams.userId) || null);

                    setConfirmEmailCode(queryParams.token || null);

                    break;

                default:
                    setCurrentScreen('login');
            }

            history.replace(location.pathname); // remove the query params
        }
    }, [history, location.pathname, setProfileModalState]);

    const _showLogin = () => {
        if (firebasePopupOpen) {
            // This can only happen if the user filled the form and afterwards clicks on a social login and then clicks the submit button again
            return showError('A autenticação já foi iniciada. Por favor, finalize o processo na outra janela.');
        }

        return setCurrentScreen('login');
    };

    // const _toggleModal = () => {
    //     setProfileModalState(!isOpen);

    //     if (isOpen) {
    //         document.body.style.overflow = 'auto';
    //     }

    //     _showLogin();
    // };

    // const _logout = () => {
    //     try {
    //         document.cookie = cookie.serialize('auth_jwt', '', {
    //             path: '/',
    //             sameSite: 'strict',
    //             expires: new Date('Thu, 01 Jan 1970 00:00:01 GMT'),
    //         });

    //         setCurrentScreen('login');

    //         setUserId(null);

    //         setConfirmEmailCode(null);

    //         const logoutBtnClicked = false

    //         setLogoutBtnClicked(logoutBtnClicked);

    //         // reset the stream (if a (semi) pro stream was playing) (This could/should?! be done in the props.logout function)
    //         if (currentStream.get('semiPro') || currentStream.get('pro')) {
    //             setStream('antena_1');
    //         }

    //         logout(); // Maybe do this first and wait for it to return before resetting everything else here?!
    //     } catch (error) {
    //         showError(error);
    //     }
    // };

    const _showRequestPasswordReset = () => {
        setCurrentScreen('request-password-reset');
    };

    const _showRegister = () => {
        if (firebasePopupOpen) {
            // This can only happen if the user filled the form and afterwards clicks on a social login and then clicks the submit button again
            return showError('A autenticação já foi iniciada. Por favor, finalize o processo na outra janela.');
        }

        return setCurrentScreen('register');
    };


    useEffect(() => {
        // if userId is given but email is not confirmed, send to email confirmation screen
        // Note: The user profile is only fetched after this component was loaded...
        if (user && user.userId && !user.emailConfirmed && currentScreen !== 'confirm-email') {
            setUserId(user.userId);

            setCurrentScreen('confirm-email');
        }
    }, [user, currentScreen]);

    useEffect(() => {
        if (__CLIENT__) {
            setTimeout(() => _handleQueryParams(params), 1500);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div id="searchBoxModal">
            <ReactModal
                shouldCloseOnOverlayClick
                shouldCloseOnEsc
                isOpen={isOpen}
                onRequestClose={_handleClose}
                contentLabel="Modal"
                closeTimeoutMS={500}
                className={isOpen ? 'modalComponent' : 'beforeCloseModal'}
                overlayClassName="overlayModal"
            >
                <div className="contentModal">
                    <div className="closeModal">
                        <Button title="Fechar janela" ariaLabel="Fechar janela" onClick={_handleClose}>
                            &nbsp;
                        </Button>
                    </div>
                    <div className="containerModalContent">
                        <Button className="close-modal" title="Fechar janela" onClick={_handleClose}>
                            <svg width="16" height="16" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.7802 13.719C14.8499 13.7887 14.9052 13.8714 14.9429 13.9625C14.9806 14.0535 15 14.1511 15 14.2496C15 14.3482 14.9806 14.4457 14.9429 14.5368C14.9052 14.6278 14.8499 14.7105 14.7802 14.7802C14.7105 14.8499 14.6278 14.9052 14.5368 14.9429C14.4457 14.9806 14.3482 15 14.2496 15C14.1511 15 14.0535 14.9806 13.9625 14.9429C13.8714 14.9052 13.7887 14.8499 13.719 14.7802L7.5 8.56025L1.28097 14.7802C1.14025 14.9209 0.949387 15 0.750375 15C0.551363 15 0.360502 14.9209 0.21978 14.7802C0.0790571 14.6395 3.923e-09 14.4486 0 14.2496C-3.923e-09 14.0506 0.0790571 13.8598 0.21978 13.719L6.43975 7.5L0.21978 1.28097C0.0790571 1.14025 0 0.949387 0 0.750375C0 0.551363 0.0790571 0.360502 0.21978 0.21978C0.360502 0.0790571 0.551363 0 0.750375 0C0.949387 0 1.14025 0.0790571 1.28097 0.21978L7.5 6.43975L13.719 0.21978C13.8598 0.0790571 14.0506 -3.923e-09 14.2496 0C14.4486 3.923e-09 14.6395 0.0790571 14.7802 0.21978C14.9209 0.360502 15 0.551363 15 0.750375C15 0.949387 14.9209 1.14025 14.7802 1.28097L8.56025 7.5L14.7802 13.719Z" fill="black" />
                            </svg>
                        </Button>
                        <div className="infoModal">
                            <div className="form">
                                {/* {isLoggedIn ? (
                                    <MenuProfile
                                        logout={_logout}
                                        isOpenMenuProfile={openMenuProfile}
                                        setIsOpenMenuProfile={setOpenMenuProfile}
                                    />
                                ) : (
                                    <React.Fragment>
                                        <UnmountClosed isOpened={currentScreen === 'login'}>
                                            <Login onRequestPasswordReset={_showRequestPasswordReset} />
                                        </UnmountClosed>
                                        <UnmountClosed isOpened={currentScreen === 'register'}>
                                            <Register />
                                        </UnmountClosed>
                                        <UnmountClosed isOpened={currentScreen === 'confirm-email'}>
                                            <ConfirmEmail userId={userId} code={confirmEmailCode} />
                                        </UnmountClosed>
                                        <UnmountClosed isOpened={currentScreen === 'request-password-reset'}>
                                            <RequestPasswordReset />
                                        </UnmountClosed>
                                        <UnmountClosed isOpened={currentScreen === 'reset-password'}>
                                            <ResetPassword resetToken={confirmEmailCode} userId={userId} />
                                        </UnmountClosed>
                                    </React.Fragment>
                                )} */}

                                <React.Fragment>
                                    <UnmountClosed isOpened={currentScreen === 'login'}>
                                        <Login onRequestPasswordReset={_showRequestPasswordReset} />
                                    </UnmountClosed>
                                    <UnmountClosed isOpened={currentScreen === 'register'}>
                                        <Register />
                                    </UnmountClosed>
                                    <UnmountClosed isOpened={currentScreen === 'confirm-email'}>
                                        <ConfirmEmail userId={userId} code={confirmEmailCode} />
                                    </UnmountClosed>
                                    <UnmountClosed isOpened={currentScreen === 'request-password-reset'}>
                                        <RequestPasswordReset />
                                    </UnmountClosed>
                                    <UnmountClosed isOpened={currentScreen === 'reset-password'}>
                                        <ResetPassword resetToken={confirmEmailCode} userId={userId} />
                                    </UnmountClosed>
                                </React.Fragment>
                            </div>
                            {!isLoggedIn &&
                            <div>
                                {currentScreen !== 'login' &&
                                <button type="submit" className="cta login tw-mb-4" onClick={_showLogin}>
                                    <FontAwesomeIcon icon={faArrowLeft} width={20} className="tw-mr-2" />
                                    {' '}
                                    Voltar para o login
                                </button>}
                                {currentScreen !== 'register' &&
                                <p>
                                    Não tem uma conta?
                                    <Button title="Faça seu cadastro" className={currentScreen === 'register' ? 'btnVisibleRegister actButton' : 'btnVisibleRegister'} onClick={_showRegister} disabled={!!submitting}>Faça o seu cadastro.</Button>
                                </p>}
                            </div>}
                            {!isLoggedIn && currentScreen === 'register' &&
                            <div className="tw-mt-5">
                                <p className="tw-m-0">
                                    <small>
                                        Ao se cadastrar em nosso site, você concorda com nossa
                                        <Button href="/termos/privacidade" className="TextLink" title="Link -  Politica de privacidade">Politica de Privacidade</Button>
                                        .
                                    </small>
                                </p>
                            </div>}
                        </div>
                    </div>
                </div>
            </ReactModal>
        </div>
    );
};

ProfileModal.propTypes = exact({
    isOpen: PropTypes.bool.isRequired,
    submitting: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]).isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    setProfileModalState: PropTypes.func.isRequired,
    user: PropTypes.object,
    firebasePopupOpen: PropTypes.bool.isRequired,
    logout: PropTypes.func,
    currentStream: PropTypes.any,
    setStream: PropTypes.func,
});

export default ProfileModal;
